<template>
  <v-container fluid id="login-container">
    <snackbar ref="alert"></snackbar>

    <v-layout justify-center fill-height align-center>
      <v-flex xs3 row wrap align-items-center justify-center>
        <v-card height="150" width="300">
          <v-card-title class="elevation-2">
            <span style="width: 100%;" class="text-xs-center"
              >TUGENDE LINKS</span
            >
          </v-card-title>
          <v-card-text class="text-xs-center">
            <v-btn
              id="login-with-google-btn"
              :loading="authenticating"
              color="primary"
              @click="login"
              :disabled="!gapi"
              >Login With Google</v-btn
            >
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import {
  getFirebaseUser,
  prodProcessFirebaseUser
} from "../services/authentication";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    Snackbar
  },
  data: () => ({
    authenticating: false,
    gapi: undefined
  }),
  async mounted() {
    this.gapi = await this.$getGapiClient();
  },
  methods: {
    ...mapMutations(["addCurrentUser", "addCredentials", "addGapiCredentials"]),
    ...mapActions(["createUser"]),
    async login() {
      try {
        this.authenticating = true;
        await this.$login();

        const googleAuth = this.gapi.auth2.getAuthInstance();
        const googleUser = await googleAuth.currentUser.get();
        const googleAuthResponse = googleUser.getAuthResponse();
        const token = googleAuthResponse.id_token;
        const result = await getFirebaseUser(token);

        this.addCredentials(result.credential);
        this.addGapiCredentials(googleAuthResponse);
        prodProcessFirebaseUser(result.user, (err, processedUser) => {
          if (!err) {
            this.addCurrentUser(processedUser);
            // console.log(processedUser);
            this.createUser(processedUser);
            this.$refs.alert.open(
              "success",
              `Logged in as ${result.user.displayName}`
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$refs.alert.open("error", err.message);
          }
        });
      } catch (error) {
        this.$refs.alert.open("error", error.message);
      } finally {
        this.authenticating = false;
      }
    }
  }
};
</script>

<style scoped>
#login-container {
  background-color: rgba(255, 62, 181, 0.2);
}
</style>
